export default __webpack_public_path__ + "static/media/tick-care.cc87fd00.svg";